export * from './translationKeys';
export * from '../constants-generated';
export const FAILED_TO_FETCH_DATA_MESSAGE = 'Failed to fetch data';
export const SHOPPING_BASKET_PATH = '/shopping/basket';
export const SUBSCRIPTIONS_PATH = '/mypages/order/subscriptions';
